import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { LineChart } from "@mui/x-charts/LineChart";
import { TeamContext } from "../component/context/TeamContext";
import Division from "../component/standings/division";
import Wildcard from "../component/standings/wildcard";
import Conference from "../component/standings/conference";
import League from "../component/standings/league";
import apiUrl from "../config";
import allTeams from "../data/teams"; // Adjust the import path as necessary
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import AdBanner from "../component/ads/AdBanner";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const Standings: React.FC = ({}) => {
  const [teams, setTeams] = useState(allTeams || []);
  const [teamsStanding, setTeamsStanding] = useState([]);
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const fetchStandingTeams = async () => {
    let data = [];
    try {
      const response = await axios.get(`${apiUrl}/api/teamStanding/`);
      data = response.data.standings;
    } catch (error) {
      console.error("Error fetching standing teams:", error);
    }
    return data;
  };

  useEffect(() => {
    const fetchAndSetTeamsStanding = async () => {
      const standingsData = await fetchStandingTeams();
      setTeamsStanding(standingsData);
    };
    fetchAndSetTeamsStanding();
  }, []);

  return (
    <div className="wrapper">
      <div className="main">
        <div className="teamContent">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Wild Card" {...a11yProps(0)} />
                <Tab label="Division" {...a11yProps(1)} />
                <Tab label="Conference" {...a11yProps(2)} />
                <Tab label="League" {...a11yProps(3)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Wildcard teamsStanding={teamsStanding} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Division teamsStanding={teamsStanding} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Conference teamsStanding={teamsStanding} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <League teamsStanding={teamsStanding} />
            </CustomTabPanel>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Standings;
